export const itdageneBlue = '#0778BC';
export const itdageneLightBlue = '#41C0EB';
export const itdageneDarkBlue = '#123962';
export const itdageneGreen = '#3AB07B';
export const itdageneYellow = '#F4C20E';
export const itdageneRed = '#E01E5B';
export const lightGrey = '#e2e9f1';

export const blueNCS = '#3092BF';
export const princetonOrange = '#F5821E';
export const skyBlue = '#7CD1EE';
export const indigoDye = '#0E3B66';
export const white = '#FFFFFF';
